import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SliderArrow extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
  }

  render() {
    let { type, onClick, className } = this.props;

    return type === 'next'
    ? (
      <div
        onClick={onClick}
        className={className}
      >
          Next
          <svg><use xlinkHref="#arrow-right" /></svg>
      </div>
    )
    : (
      <div
        onClick={onClick}
        className={className}
      >
          Previous
          <svg><use xlinkHref="#arrow-left" /></svg>
      </div>
    )
  }
}

export default SliderArrow;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileSlider/SliderArrow.js